<template>
    <v-btn
        :icon="icon"
        :color="color"
        :class="classes"
        @click="editSchool()"
    >
        <slot></slot>
    </v-btn>
</template>
<script>

  import { mapActions } from 'vuex';

  import { schoolsService } from '../../utils/services/schools.service';
  import SchoolModal from '../modals/Schools/SchoolModal.vue';

export default {
    name: 'BtnAddEditTeacher',
    props: {
        id: {
            type: Number,
            default: 0,
        },
        icon: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: '',
        },
        classes: {
            type: String,
            default: '',
        },
        returnUrl: {
            type: String,
            default: '',
        },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      editSchool() {
         this.$router.push({ path: `/schools/${this.id}/show?tab=school&returnUrl=${this.returnUrl}` });
      },
/*
      async showSchoolModal(id) {
        this.showModal({
          component: SchoolModal,
            data: {
              stored: {
                id,
                return_url: this.returnUrl,
              },
          },
          options: {
            title: this.$t('TEACHER'),
            onSave: (
              form,
              error,
            ) => schoolsService.save(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.$emit('actionend');
            }),
          },
        });
      },
      */
    },
};
</script>
